__turbopack_context__.v({
  "body": "FilterSliderNew-module__8N61ha__body",
  "checkboxList": "FilterSliderNew-module__8N61ha__checkboxList",
  "checkmark": "FilterSliderNew-module__8N61ha__checkmark",
  "drawer": "FilterSliderNew-module__8N61ha__drawer",
  "filerSection": "FilterSliderNew-module__8N61ha__filerSection",
  "filterContainer": "FilterSliderNew-module__8N61ha__filterContainer",
  "filterDescription": "FilterSliderNew-module__8N61ha__filterDescription",
  "filterSearch": "FilterSliderNew-module__8N61ha__filterSearch",
  "filterSearchBox": "FilterSliderNew-module__8N61ha__filterSearchBox",
  "filterSearchTerm": "FilterSliderNew-module__8N61ha__filterSearchTerm",
  "filterTypeText": "FilterSliderNew-module__8N61ha__filterTypeText",
  "modal": "FilterSliderNew-module__8N61ha__modal",
  "modalBody": "FilterSliderNew-module__8N61ha__modalBody",
  "modalButtonPrimary": "FilterSliderNew-module__8N61ha__modalButtonPrimary",
  "modalButtonSecondary": "FilterSliderNew-module__8N61ha__modalButtonSecondary",
  "modalFooter": "FilterSliderNew-module__8N61ha__modalFooter",
  "modalHeader": "FilterSliderNew-module__8N61ha__modalHeader",
  "overlay": "FilterSliderNew-module__8N61ha__overlay",
  "showDrawer": "FilterSliderNew-module__8N61ha__showDrawer",
});
